import { css } from "lit";
export default css `
    
    :host {
        --paddy: 5px;
    }
    
    .tiny {
        font-size: 0.8rem!important;
        border-right: none!important;
        border-bottom: none!important;
    }
    
    .kv-table > table {
        width: 100%;
        border-spacing: 0;
    }

    .kv-table > table > thead > tr > th {
        font-family: var(--font-stack), sans-serif;
        background: var(--kv-table-header-background);
        text-align: left;
        padding: var(--paddy);
        color: var(--font-color);
        font-weight: normal;
        border-bottom: 1px dashed var(--kv-table-dividers);
        border-top: 1px dashed var(--kv-table-header-border-top);
    }

    .kv-table > table > thead > tr > th:first-child {
        font-family: var(--font-stack-bold), sans-serif;
        background: var(--kv-table-header-background-reversed);
        text-align: right;
        color: var(--primary-color);
        padding-right: var(--paddy);
    }

    .kv-table > table > thead > tr > th:nth-child(2) {
        font-family: var(--font-stack-bold), sans-serif;
    }

    .kv-table > table > tbody > tr > td {
        font-family: var(--font-stack), sans-serif;
        padding: var(--paddy) 0 var(--paddy) var(--paddy);
        border-bottom: 1px dashed var(--kv-table-dividers);
    }

    .kv-table > table > tbody > tr > td:first-child > code {
        color: var(--primary-color);
        font-family: var(--font-stack-bold), sans-serif;
    }

    .kv-table > table > tbody > tr > td:nth-child(2) {
        color: var(--font-color-sub1)
    }
    
    .kv-table > table > tbody > tr > td:nth-child(2) > code {
        font-family: var(--font-stack), sans-serif;
        border: 1px solid var(--secondary-color-lowalpha);
        color: var(--secondary-color);
        border-radius: 0;
        padding: 0 5px 1px 5px;
        background-color: var(--secondary-color-very-lowalpha);
    }
    
    .kv-table > table > tbody > tr > td:first-child {
        width: 180px;
        vertical-align: top;
        text-align: right;
        padding-right: var(--paddy);
        border-right: 1px dashed var(--kv-table-dividers);
    }

    .kv-table >table > tbody > tr > td > code {
        color: var(--secondary-color);
        font-weight: normal;
    }

    .kv-table >table > tbody > tr > td > a {
       font-size: 14px;
    }

    
    pre {
        word-wrap: break-word;
        white-space: pre-wrap;
        max-width: 760px;
        overflow-x: auto;
        margin-top: 0;
        margin-bottom: 0;
    }

    pre > code {
        word-wrap: break-word;
        white-space: pre-wrap;
    }
    
    .no-box {
        border: none;
        background: none;
    }


`;
